<template>

    <div class="index background">

        <div class="userinfo">

            <div class="userinfo-title">意见反馈</div>

            <div class="from">

                <div class="userinfo-floor cf">

                    <div class="userinfo-floor-label floor-label fl">问题类型</div>

                    <div class="userinfo-floor-value fl cf">

                        <div
                            class="type-item cf fl"
                            v-for="(item,index) in typeList"
                            :key="'type-item-'+index"
                            @click="type = item.id"
                        >

                            <div class="type-item-icon fl">

                                <img v-if="type === item.id" src="./images/icon_radio_s@2x.png" />

                                <img v-else src="./images/icon_radio_n@2x.png" />

                            </div>

                            <div class="fl">{{ item.label }}</div>

                        </div>

                    </div>

                </div>

                <div class="userinfo-floor cf">

                    <div class="userinfo-floor-label floor-label fl">页面地址</div>

                    <div class="userinfo-floor-value fl">

                        <el-input class="width" v-model="url" placeholder="请输入"/>

                    </div>

                </div>

                <div class="userinfo-floor cf">

                    <div class="userinfo-floor-label floor-label fl">联系方式</div>

                    <div class="userinfo-floor-value fl">

                        <el-input class="width" v-model="phone" placeholder="请输入电话、QQ或者邮箱"/>

                    </div>

                </div>

                <div class="userinfo-textarea cf">

                    <div class="userinfo-floor-label floor-label fl">详情描述<span>*</span></div>

                    <div class="userinfo-text fl">

                        <el-input
                            type="textarea"
                            placeholder="请输入反馈内容"
                            v-model="content">
                        </el-input>

                    </div>

                </div>

                <div class="button save-btn button-active" @click="submitInfo">提交反馈</div>

            </div>

        </div>

    </div>

</template>

<script>
import mixin from "./mixin/mixin";
export default {
    name: "userinfo",
    mixins: [mixin]
}
</script>

<style scoped src="./style.css"></style>
